var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    viewBox: "0 0 39 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 35.6731H14.6666C14.1166 35.6731 13.6666 35.2442 13.6666 34.7199V26.1406C13.6666 25.6163 14.1166 25.1873 14.6666 25.1873C15.2166 25.1873 15.6666 25.6163 15.6666 26.1406V33.7666H23.6666V26.1406C23.6666 25.6163 24.1166 25.1873 24.6666 25.1873C25.2166 25.1873 25.6666 25.6163 25.6666 26.1406V34.7199C25.6666 35.2442 25.2166 35.6731 24.6666 35.6731Z",
    fill: "url(#paint0_linear_89_1407)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 40.0295C16.3566 40.0295 13.6666 37.4653 13.6666 34.31C13.6666 33.7857 14.1166 33.3567 14.6666 33.3567C15.2166 33.3567 15.6666 33.7857 15.6666 34.31C15.6666 36.4167 17.4566 38.123 19.6666 38.123C21.8766 38.123 23.6666 36.4167 23.6666 34.31C23.6666 33.7857 24.1166 33.3567 24.6666 33.3567C25.2166 33.3567 25.6666 33.7857 25.6666 34.31C25.6666 37.4653 22.9766 40.0295 19.6666 40.0295Z",
    fill: "url(#paint1_linear_89_1407)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0166 3.80587C9.7566 3.80587 9.5066 3.71054 9.3066 3.52942L7.3066 1.62291C6.9166 1.25115 6.9166 0.650596 7.3066 0.278827C7.6966 -0.0929423 8.3266 -0.0929423 8.7166 0.278827L10.7166 2.18533C11.1066 2.5571 11.1066 3.15765 10.7166 3.52942C10.5166 3.72007 10.2666 3.80587 10.0066 3.80587H10.0166Z",
    fill: "url(#paint2_linear_89_1407)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 3.80587C29.7566 3.80587 29.5066 3.71054 29.3066 3.52942C28.9166 3.15765 28.9166 2.5571 29.3066 2.18533L31.3066 0.278827C31.6966 -0.0929423 32.3266 -0.0929423 32.7166 0.278827C33.1066 0.650596 33.1066 1.25115 32.7166 1.62291L30.7166 3.52942C30.5166 3.72007 30.2666 3.80587 30.0066 3.80587H30.0166Z",
    fill: "url(#paint3_linear_89_1407)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0166 26.684C7.7566 26.684 7.5066 26.5886 7.3066 26.4075C6.9166 26.0358 6.9166 25.4352 7.3066 25.0634L9.3066 23.1569C9.6966 22.7852 10.3266 22.7852 10.7166 23.1569C11.1066 23.5287 11.1066 24.1292 10.7166 24.501L8.7166 26.4075C8.5166 26.5982 8.2666 26.684 8.0066 26.684H8.0166Z",
    fill: "url(#paint4_linear_89_1407)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0166 26.684C31.7566 26.684 31.5066 26.5886 31.3066 26.4075L29.3066 24.501C28.9166 24.1292 28.9166 23.5287 29.3066 23.1569C29.6966 22.7852 30.3266 22.7852 30.7166 23.1569L32.7166 25.0634C33.1066 25.4352 33.1066 26.0358 32.7166 26.4075C32.5166 26.5982 32.2666 26.684 32.0066 26.684H32.0166Z",
    fill: "url(#paint5_linear_89_1407)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 14.7016H1.66663C1.11663 14.7016 0.666626 14.2726 0.666626 13.7483C0.666626 13.224 1.11663 12.7951 1.66663 12.7951H3.66663C4.21663 12.7951 4.66663 13.224 4.66663 13.7483C4.66663 14.2726 4.21663 14.7016 3.66663 14.7016Z",
    fill: "url(#paint6_linear_89_1407)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 14.7016H35.6666C35.1166 14.7016 34.6666 14.2726 34.6666 13.7483C34.6666 13.224 35.1166 12.7951 35.6666 12.7951H37.6666C38.2166 12.7951 38.6666 13.224 38.6666 13.7483C38.6666 14.2726 38.2166 14.7016 37.6666 14.7016Z",
    fill: "url(#paint7_linear_89_1407)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 28.0471H14.6666C14.1166 28.0471 13.6666 27.6181 13.6666 27.0939V24.2436C12.6266 23.6526 11.5666 22.9758 10.6466 22.0988C8.1966 19.7633 6.8766 16.6462 6.9266 13.3193C6.9766 10.0211 8.3566 6.91347 10.8266 4.56847C13.2766 2.22346 16.5466 0.936569 20.0166 0.936569C23.4866 0.936569 26.7566 2.22346 29.2066 4.56847C31.6566 6.90394 32.9766 10.0211 32.9266 13.3479C32.8766 16.6462 31.4966 19.7538 29.0266 22.0988C28.0966 22.9758 26.8366 23.6431 25.8166 24.1674C25.7666 24.196 25.7066 24.2246 25.6566 24.2532V27.0939C25.6566 27.6181 25.2066 28.0471 24.6566 28.0471H24.6666ZM15.6666 26.1406H23.6666V23.7003C23.6666 23.3571 23.8566 23.0425 24.1666 22.8709C24.3766 22.7566 24.6166 22.6326 24.8666 22.4992C25.7666 22.0225 26.8966 21.4411 27.6166 20.7547C29.7066 18.7624 30.8866 16.1219 30.9266 13.3289C30.9666 10.5263 29.8566 7.89532 27.7866 5.93162C25.7066 3.94885 22.9466 2.86214 20.0066 2.86214C17.0666 2.86214 14.3066 3.94885 12.2266 5.93162C10.1366 7.92392 8.9566 10.5644 8.9166 13.3575C8.8766 16.16 9.9866 18.791 12.0566 20.7547C12.9566 21.6126 14.0766 22.2799 15.1566 22.8709C15.4666 23.0425 15.6566 23.3571 15.6566 23.7003V26.1406H15.6666Z",
    fill: "url(#paint8_linear_89_1407)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3666 19.6871C14.1066 19.6871 13.8566 19.5918 13.6566 19.4106C11.9566 17.7901 11.0166 15.6357 11.0166 13.3479C11.0166 11.0601 11.9566 8.90577 13.6566 7.28524C14.0466 6.91347 14.6766 6.91347 15.0666 7.28524C15.4566 7.65701 15.4566 8.25756 15.0666 8.62933C13.7466 9.88763 13.0166 11.5654 13.0166 13.3479C13.0166 15.1305 13.7466 16.8082 15.0666 18.0665C15.4566 18.4383 15.4566 19.0389 15.0666 19.4106C14.8666 19.6013 14.6166 19.6871 14.3566 19.6871H14.3666Z",
    fill: "url(#paint9_linear_89_1407)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 32.2891C24.5166 32.2891 24.3566 32.2605 24.2166 32.1842L14.5666 27.5324C14.0766 27.294 13.8766 26.7221 14.1266 26.255C14.3766 25.7879 14.9766 25.5972 15.4666 25.8356L25.1166 30.4874C25.6066 30.7258 25.8066 31.2977 25.5566 31.7648C25.3766 32.0984 25.0266 32.2891 24.6666 32.2891Z",
    fill: "url(#paint10_linear_89_1407)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2266 35.2632C23.0766 35.2632 22.9266 35.2347 22.7866 35.1679L14.5866 31.3549C14.0866 31.1261 13.8866 30.5542 14.1266 30.0775C14.3666 29.6009 14.9666 29.4103 15.4666 29.639L23.6666 33.4521C24.1666 33.6808 24.3666 34.2528 24.1266 34.7294C23.9566 35.0726 23.5966 35.2632 23.2266 35.2632Z",
    fill: "url(#paint11_linear_89_1407)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_1407",
    x1: -4.59337,
    y1: 52.5267,
    x2: 38.3473,
    y2: 9.48235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_1407",
    x1: -2.02337,
    y1: 55.0909,
    x2: 40.9173,
    y2: 12.0466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_89_1407",
    x1: -24.6234,
    y1: 32.5465,
    x2: 18.3172,
    y2: -10.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_89_1407",
    x1: -14.1234,
    y1: 43.0227,
    x2: 28.8172,
    y2: -0.0215857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_89_1407",
    x1: -12.6334,
    y1: 44.5003,
    x2: 30.3072,
    y2: 1.45596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_89_1407",
    x1: -2.1334,
    y1: 54.9765,
    x2: 40.8072,
    y2: 11.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_89_1407",
    x1: -21.4434,
    y1: 35.7113,
    x2: 21.4973,
    y2: -7.33304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_89_1407",
    x1: -5.22337,
    y1: 51.9071,
    x2: 37.7173,
    y2: 8.86274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_89_1407",
    x1: -12.8134,
    y1: 44.3287,
    x2: 30.1272,
    y2: 1.28437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_89_1407",
    x1: -16.0834,
    y1: 41.0686,
    x2: 26.8572,
    y2: -1.97575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_89_1407",
    x1: -5.25338,
    y1: 51.8689,
    x2: 37.6873,
    y2: 8.82461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_89_1407",
    x1: -3.82338,
    y1: 53.2988,
    x2: 39.1173,
    y2: 10.2545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbGradient);
export default __webpack_public_path__ + "static/media/lightbulb-gradient.226f7c3e95f2b9e42f00688e032abec9.svg";
export { ForwardRef as ReactComponent };